import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/aboutpage/business-culture/workers -img.png")